export const VideoUploadViewerType = 'wixui.VideoUpload' as const;
export const VideoUploadData = 'VideoUploadData';

export const CONTROLS_HIDE_TIMEOUT = 2000;
export const SEEK_INTERVAL_IN_SECONDS = 5;
export const VOLUME_STEP = 0.05;
export const PLAYBACK_RATES = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2] as const;

export const ICON_SIZE_MAP: Record<'medium' | 'large', number> = {
  medium: 20,
  large: 24,
};
